export default "__VITE_ASSET__BGaNTdr9__"